import PropTypes from 'prop-types'
import React, { useMemo } from 'react'
import { Col, Grid } from 'gu-ui-kit'
import clsx from 'clsx'
import { ReactComponent as ContentBgSVG } from 'images/auth/bg.svg'
import { BackButton, Langs, Logo } from 'layouts/AuthLayout/subcomponents'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'
import { ROUTES } from 'constants/routes'
import { useSelector } from 'react-redux'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import styles from 'layouts/AuthLayout/AuthLayout.module.scss'
import { useLocation } from 'react-router-dom'

export const AuthLayout = ({ children = null }) => {
  const { i18n } = useSelector(({ app }) => app)
  const pathGen = useGeneratePathI18n()
  const location = useLocation()
  const breakpoint = useBreakpoint()

  const isLoginOrRegisterPage = useMemo(
    () =>
      [pathGen(ROUTES.AUTH_LOGIN), pathGen(ROUTES.AUTH_REGISTRATION)].includes(location.pathname),
    [location],
  )

  const url = useMemo(() => {
    if (isLoginOrRegisterPage) {
      return pathGen(ROUTES.MAIN)
    }
    return pathGen(ROUTES.AUTH_LOGIN)
  }, [i18n, isLoginOrRegisterPage])

  return (
    <div className={styles['layout']}>
      <Grid className={styles['layout__grid']} alignItems={'center'} justifyContent={'center'}>
        <div className={styles['layout__wrapper-backgrounds']}>
          <div className={styles['layout__bgs']}>
            <div className={clsx(styles['layout__bg'], styles['layout__bg_1'])} />
            <div className={clsx(styles['layout__bg'], styles['layout__bg_2'])} />
            <div className={clsx(styles['layout__bg'], styles['layout__bg_3'])} />
          </div>
        </div>
        <Grid
          alignItems={'center'}
          justifyContent={'start'}
          direction={'column'}
          gap={breakpoint.fbs ? 77 : 86}
          wrap={false}
          className={styles['layout__wrapper-content']}
        >
          <Col flexGrow={0} flexShrink={0} className={styles['layout__content']}>
            <Grid
              className={breakpoint.fbs ? 'margin-bottom-40' : 'margin-bottom-64'}
              cols={3}
              justifyContent={'between'}
              alignItems={'center'}
            >
              <Col>
                <BackButton url={url} />
              </Col>
              <Grid justifyContent={'center'}>
                <Logo />
              </Grid>
              <Grid justifyContent={'end'}>
                <Grid
                  alignItems={'center'}
                  justifyContent={'end'}
                  wrap={false}
                  className={styles['layout__lang']}
                  fluid={false}
                >
                  <Langs />
                </Grid>
              </Grid>
            </Grid>
            {children}
          </Col>
          <Col flexGrow={0} flexShrink={0}>
            <ContentBgSVG className={styles['layout__content-bg']} />
          </Col>
        </Grid>
      </Grid>
    </div>
  )
}

AuthLayout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.oneOf([null]),
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element,
  ]).isRequired,
}
